import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { UtilityService } from '../services/utility.service';

@Injectable({
  providedIn: 'root',
})
export class ConsoleGuard  {
  /**
   * Initilizes
   * @param us Initilizes
   */
  constructor(private readonly us: UtilityService) {}

  canLoad(route: Route): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isLoggedIn()) {
      return true;
    }
    window.open(environment.signinUrl, '_self');
    return false;
  }

  /**
   *
   * isLoggedIn
   */
  isLoggedIn(): boolean {
    if (this.us.getCookie('ILG')) {
      return true;
    }
    return false;
  }

  sharedUrl() {
    const param = this.us.getUrlQueryParam();
    if (param && param['workspaceId'] && param['invitedBy']) {
      this.us.setCookie('url', window.location.href);
    }
  }
}
